import { render, staticRenderFns } from "./WxPunchInRecord.vue?vue&type=template&id=157b0b8a&scoped=true&"
import script from "./WxPunchInRecord.vue?vue&type=script&lang=js&"
export * from "./WxPunchInRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b0b8a",
  null
  
)

export default component.exports